export default function getOffset(el) {
	var x = 0
	var y = 0
	while(el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
		x += el.offsetLeft
		y += el.offsetTop
		el = el.offsetParent
	}
	return {top: y, left: x}
}
